import { StubPage } from '../StubPage'
export function Journeys() {
  return <StubPage title="Journeys" summary="A Journey is one execution of a Preparation. The Journeys list in the Console shows all running and completed journeys, their current state (pending, running, paused, completed, failed), and which user triggered them. Click a journey to inspect its step-by-step log and payload." />
}
